import React from 'react';

// The login card's own controls (css.css, .fld and .go). Square, no MUI: a baseline-only text field that turns light blue and draws a bar
// across its foot while it has focus, and the engros.ai style black button (see EngrosAiButton.css in the application) with a green segment
// chasing the outline on hover and three green pulses beside the label while a request is running.

export function CardField({id, name, label, type = 'text', value, onChange, autoComplete, autoFocus, inputRef, onKeyDown, action}) {
	return (
		<div className="fld">
			<label htmlFor={id}>{label}</label>
			<input id={id} name={name} type={type} value={value} onChange={onChange} autoComplete={autoComplete} autoFocus={autoFocus} ref={inputRef} onKeyDown={onKeyDown} />
			{action}
			<span className="rule" />
		</div>
	);
}

// `busy` lights the closed outline and the pulses, and swaps the label for `busyLabel` when one is given. `error` turns the outline red and
// closed until the next try (it fades in once, since the class comes off while a request runs and goes back on after a failure).
export function GoButton({children, busyLabel, busy = false, error = false, disabled = false, buttonRef, type = 'submit', onClick}) {
	return (
		<span className={`go-wrap${busy ? ' busy' : ''}${error && !busy ? ' err' : ''}`}>
			<button className="go" type={type} ref={buttonRef} disabled={disabled || busy} onClick={onClick}>
				<span className="inner">
					<span>{busy && busyLabel ? busyLabel : children}</span>
					<span className="pulses" aria-hidden="true">
						<i />
						<i />
						<i />
					</span>
				</span>
			</button>
			<svg className="go-ring" viewBox="0 0 100 32" preserveAspectRatio="none" aria-hidden="true">
				<rect x="1" y="1" width="98" height="30" rx="0" ry="0" pathLength="100" />
			</svg>
		</span>
	);
}
